"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToConcentrationLimitReceivables = exports.transformToConcentrationLimitReceivable = void 0;
const progressHelper_1 = require("./progressHelper");
const receivableBorrowingBaseTestWaivers_1 = require("./receivableBorrowingBaseTestWaivers");
const transformToConcentrationLimitReceivable = ({ creditFacilityReceivable, calcAgentMechanics, waivedEligibilityTestKeysForReceivable, }) => {
    const concentrationLimitReceivable = {
        ...creditFacilityReceivable,
        valuationFields: {
            valuation: 0,
            valuationRate: 0,
        },
        eligibilityStatuses: [],
        eligibilityFields: {
            eligibilityKickout: 0,
            eligibleExposure: 0,
            isEligible: true,
        },
        concentrationLimitFields: {
            eligibleExposureLessConcentrationLimitKickouts: 0,
        },
        concentrationLimitReasons: [],
        concentrationLimitWaivers: [],
    };
    // Run ValuationRate and set for target receivable
    const valuationBaseFields = calcAgentMechanics.evaluateValuationRate(creditFacilityReceivable);
    concentrationLimitReceivable.valuationFields = valuationBaseFields;
    // Run Eligibility + exposure and set for target receivable
    const { isEligible, eligibilityStatuses, } = calcAgentMechanics.evaluateEligibility({
        valuationReceivable: concentrationLimitReceivable,
        waivedEligibilityTestKeysForReceivable,
    });
    const eligibleExposure = isEligible ? valuationBaseFields.valuation : 0;
    const eligibilityKickout = isEligible ? 0 : valuationBaseFields.valuation;
    concentrationLimitReceivable.eligibilityStatuses = eligibilityStatuses;
    concentrationLimitReceivable.eligibilityFields = {
        isEligible,
        eligibleExposure,
        eligibilityKickout,
    };
    concentrationLimitReceivable.concentrationLimitFields = {
        eligibleExposureLessConcentrationLimitKickouts: eligibleExposure,
    };
    return concentrationLimitReceivable;
};
exports.transformToConcentrationLimitReceivable = transformToConcentrationLimitReceivable;
const convertToConcentrationLimitReceivables = async ({ creditFacilityReceivables, calcAgentMechanics, progressCallback, receivableWaivers, }) => {
    const concentrationLimitReceivables = [];
    const groupedReceivableWaiversByFinleyReceivableId = (0, receivableBorrowingBaseTestWaivers_1.groupReceivableBorrowingBaseTestWaivers)({ receivableBorrowingBaseTestWaivers: receivableWaivers });
    const { updateProgress } = (0, progressHelper_1.createProgressHelper)({
        operation: 'Evaluate eligibility criteria',
        progressCallback,
        numRows: creditFacilityReceivables.length,
    });
    // We use a "for" loop here instead of "map" to allow for progress updates
    let progressIndex = 0;
    for (const creditFacilityReceivable of creditFacilityReceivables) {
        // eslint-disable-next-line no-await-in-loop, no-plusplus
        await updateProgress(progressIndex++);
        const waivedEligibilityTestKeysForReceivable = groupedReceivableWaiversByFinleyReceivableId[creditFacilityReceivable.finleyReceivableId] ?? new Set();
        const concentrationLimitReceivable = (0, exports.transformToConcentrationLimitReceivable)({
            creditFacilityReceivable,
            calcAgentMechanics,
            waivedEligibilityTestKeysForReceivable,
        });
        // Add new receivable object to resulting array
        concentrationLimitReceivables.push(concentrationLimitReceivable);
    }
    return concentrationLimitReceivables;
};
exports.convertToConcentrationLimitReceivables = convertToConcentrationLimitReceivables;
//# sourceMappingURL=convertToConcentrationLimitReceivables.js.map